import { render } from "./homeslide2.vue?vue&type=template&id=3b3ea0a4&scoped=true"
import script from "./homeslide2.vue?vue&type=script&lang=js"
export * from "./homeslide2.vue?vue&type=script&lang=js"

import "./homeslide2.vue?vue&type=style&index=0&id=3b3ea0a4&scoped=true&lang=less"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3ea0a4"]])

export default __exports__